/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

const baseStyles = () => {
    return css`
        .sku {
            display: block;
            text-align: center;
            ${theme.typography.body_small};
            color: var(--colors-text-primary);
        }
    `;
};

export const styles = () => css`
    ${baseStyles()}
`;
